var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM8.69928 12.0832L12.6752 7.26626C12.9574 6.92431 12.909 6.4183 12.5671 6.13605C12.2251 5.85381 11.7191 5.90221 11.4369 6.24416L8.05754 10.3384L6.23345 8.28625C5.93888 7.95486 5.43143 7.92501 5.10004 8.21958C4.76865 8.51415 4.7388 9.0216 5.03337 9.35299L7.48008 12.1055C7.63584 12.2808 7.86041 12.3792 8.09481 12.3749C8.32922 12.3706 8.55004 12.264 8.69928 12.0832Z",
    fill: "#109B58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.fe20f113d1d070aa025ae4c911194988.svg";
export { ForwardRef as ReactComponent };